import '../css/article.css';
import '../css/wa.css';
import { IoTimeOutline, IoHeart, IoShareSocialSharp } from "react-icons/io5";
import { MdOutlineArrowForwardIos, MdArrowForwardIos } from "react-icons/md"
import { RxDividerVertical } from "react-icons/rx";
import { FaCommentAlt, FaUser, FaEye, FaRegCalendar, FaRegClock, FaRegHeart, FaHeart, FaBookmark, FaRegBookmark, FaCheckCircle, FaRegCommentAlt } from "react-icons/fa";
import React, { useEffect, useState, useRef } from "react";
import { FaChevronDown } from "react-icons/fa6";
import { useParams } from "react-router-dom";
import axios from 'axios';
import { publishComment } from '../api/postApi';
import SunEditor from 'suneditor-react';
import { useToast } from "../components/ToastProvider";

function Article() {
    const { id } = useParams(); // URL에서 id를 가져옴
    const [loading, setLoading] = useState(true); // 로딩 상태
    const [error, setError] = useState(null); // 에러 상태
    const likeCountRef = useRef(0); // 좋아요 수 초기값 98
    const likedRef = useRef(false); // 좋아요 상태 초기값 fals
    const bookmarked = useRef(false); // 좋아요 상태 초기값 false
    const [commentData, setCommentData] = useState(null); // 에러 상태
    const [comment, setComment] = useState(null); // 에러 상태
    const [repl, setRepl] = useState(null); // 에러 상태
    const [articleData, setArticleData] = useState(null); // 아티클 데이터를 저장할 상태
    const [categoryData, setCategoryData] = useState(null); // 아티클 데이터를 저장할 상태
    const [commentCount, setCommentCount] = useState(0); // 아티클 데이터를 저장할 상태
    const [headData, setHeadData] = useState(null); // 아티클 데이터를 저장할 상태
    const [commentListData, setCommentListData] = useState(null); // 아티클 데이터를 저장할 상태
    const [writer, setWriter] = useState(null); // 아티클 데이터를 저장할 상태
    const [sortedComments, setSortedComments] = useState([]);
    const [sortType, setSortType] = useState('latest'); // 기본 최신순
    const [openReplyBox, setOpenReplyBox] = useState(null); // 열려 있는 답글 박스 ID 저장
    const [likeCount, setLikeCount] = useState(null); // 열려 있는 답글 박스 ID 저장
    const showToast = useToast();
    const [myArticle, setMyArticle] = useState([]);
    const [writerArticle, setWriterArticle] = useState([]);
    const [editorData, setEditorData] = useState('');
    const [readingTime, setReadingTime] = useState(0);
    const [saved, setSaved] = useState(null); // 열려 있는 답글 박스 ID 저장
    const [liked, setLiked] = useState(false); // 열려 있는 답글 박스 ID 저장
    const [myId, setMyId] = useState(false); // 열려 있는 답글 박스 ID 저장

    const handleReplyToggle = (commentId) => {
        setOpenReplyBox(prevId => (prevId === commentId ? null : commentId));
    };

    useEffect(() => {
        const fetchArticle = async () => {
            try {
                const token = localStorage.getItem("token");
                let response;
                if (token) {
                    response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/community/article`, { id, token });
                } else {
                    response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/community/article`, { id });
                }
                const data = response.data.data;
                const textContent = data.articleData.article.replace(/<[^>]+>/g, "").trim();
                const wordCount = textContent.split(/\s+/).length;
                const wordsPerMinute = 200;
                const readingTime = Math.ceil(wordCount / wordsPerMinute);
                setReadingTime(readingTime);
                setWriter(data.writerData);
                setArticleData(data.articleData);
                setCommentListData(data.commentData);
                setHeadData(data.headData);
                setCategoryData(data.categoryData);
                setCommentCount(data.commentData.length);
                setLiked(data.liked);
                setLikeCount(data.articleData.like);
                setSaved(data.isSaved);
                setMyId(data.myIdForDelete);
                setWriterArticle(data.writerArticles);
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    alert("해당 게시글을 찾을 수 없습니다.");
                    window.history.back(); // 이전 페이지로 이동
                } else {
                    console.error("게시글 불러오기 오류:", error);
                }
            }
        };
        
        fetchArticle();
    }, [id]);

    useEffect(() => {
        if (articleData) {
            likeCountRef.current = articleData.like;
        }
        const getMyArticle = async () => {
          try {
              const token = localStorage.getItem('token'); // 로컬 스토리지에서 토큰 가져오기
              const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/getmyarticle`, { token });
              setMyArticle(data.results);
          } catch (error) {
              console.error("Error fetching data:", error.response || error);
          }
        };
        getMyArticle();
    }, [articleData]);

    const toggleBookmark = () => {
        bookmarked.current = !bookmarked.current; // 상태 반전
        forceUpdate(); // 컴포넌트 강제 업데이트
    };

    const [, forceUpdate] = React.useReducer((x) => x + 1, 0); // 강제 렌더링용 reducer
    const [scrollPercent, setScrollPercent] = useState(0); // 스크롤 퍼센트 상태

    useEffect(() => {
        const handleScroll = () => {
        const scrollTop = window.scrollY; // 현재 스크롤 위치
        const scrollHeight = document.documentElement.scrollHeight; // 전체 문서 높이
        const clientHeight = document.documentElement.clientHeight; // 화면 높이
        const scrolled = (scrollTop / (scrollHeight - clientHeight)) * 100; // 스크롤 퍼센트 계산
        setScrollPercent(scrolled); // 상태 업데이트
        };

        window.addEventListener("scroll", handleScroll); // 스크롤 이벤트 리스너 등록
        return () => window.removeEventListener("scroll", handleScroll); // 컴포넌트 언마운트 시 이벤트 제거
    }, []);
    
    useEffect(() => {
        if (!Array.isArray(commentListData)) return; // commentListData가 배열인지 확인
    
        const sorted = [...commentListData].sort((a, b) => {
            if (sortType === 'latest') {
                return new Date(b.date) - new Date(a.date);
            } else if (sortType === 'popular') {
                return b.like - a.like;
            }
        });
    
        setSortedComments(sorted);
    }, [commentListData, sortType]);
    
    const handleEditorChange = (content) => {
        setEditorData(content);
        setCommentData(content);
    };

    const handleCommentChange = (e) => {
        setCommentData(e.target.value); // state 업데이트
      };

    const handleReplChange = (content) => {
        setRepl(content); // state 업데이트
    };


    const handleComment = async () => {
        try {
            if (!commentData || commentData.trim() === "" || commentData === "<p><br></p>") {
                alert("다시 한번 시도해주세요.")
                return
            }
            const data = {
                thisId: id,
                content: commentData,
                articleId: id,
                isRepl: false
            };
            const response = await publishComment(data);
            if (response && response.commentId) {
                setCommentData('');
                const token = localStorage.getItem("token");
                let response;
                if (token) {
                    response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/community/comment`, { id, token })
                } else {
                    response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/community/comment`, { id })
                }
                const data = response.data.comment;
                const commentCoun = data.length;
                setCommentCount(commentCoun);
                setCommentListData(data);
                 
                //리프레쉬
            } else {
                alert('실패했습니다. 다시 시도해주세요.');
            }
        } catch (error) {
            console.error('Publication error:', error);
        
            // Handle 401 Unauthorized response
            if (error.response && error.response.status === 401) {
                alert('로그인이 필요합니다. 로그인 페이지로 이동합니다.');
                window.location.href = '/login';
            } else {
                alert('오류가 발생했습니다.');
            }
        }
        
    };

    const handleRepl = async (replId) => {
        try {
            if (!repl || repl.trim() === "" || repl === "<p><br></p>") {
                alert("다시 한번 시도해주세요.")
                return
            }
            const data = {
                thisId: replId,
                content: repl,
                articleId: id,
                isRepl: true
            };
            const response = await publishComment(data);
            if (response && response.commentId) {
                setRepl('');
                const token = localStorage.getItem("token");
                let response;
                if (token) {
                    response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/community/comment`, { id, token })
                } else {
                    response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/community/comment`, { id })
                }
                const data = response.data.comment;
                const commentCoun = data.length;
                setCommentCount(commentCoun);
                setCommentListData(data);
                //리프레쉬
            } else {
                alert('실패했습니다. 다시 시도해주세요.');
            }
        } catch (error) {
            console.error('Publication error:', error);
        
            // Handle 401 Unauthorized response
            if (error.response && error.response.status === 401) {
                alert('로그인이 필요합니다. 로그인 페이지로 이동합니다.');
                window.location.href = '/login';
            } else {
                alert('오류가 발생했습니다.');
            }
        }
        
    };

    const handleCommentLike = async (targetId) => {
        const token = localStorage.getItem("token");
    
        try {
            // 댓글 좋아요 요청
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/community/like`,
                {
                    id: targetId,
                    target: "comment",
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            const response2 = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/community/comment`, { id, token })
            const data = response2.data.comment;
            const commentCoun = data.length;
            setCommentCount(commentCoun);
            setCommentListData(data);
        } catch (error) {
            console.error("Failed to like comment:", error);
    
            // 500 오류 발생 시 알림
            if (error.response && error.response.status === 500) {
                alert("로그인 후 반응할 수 있습니다.");
            }
        }
    };


    const toggleSave = async () => {
        const token = localStorage.getItem("token");
        try {
            // 댓글 좋아요 요청
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/community/save`,
                {
                    id: articleData.id,
                    token: token
                },
            );
            const saved = response.data.isSaved;
            setSaved(saved);
        } catch (error) {
            console.error("Failed to like comment:", error);
            if (error.response && error.response.status === 500) {
                alert("로그인 후 저장할 수 있습니다.");
            }
        }
    };

    const toggleLike = async () => {
        const token = localStorage.getItem("token");
    
        try {
            // 댓글 좋아요 요청
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/community/like`,
                {
                    id: articleData.id,
                    target: "article",
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            const likeCount = response.data.likeCount.like;
            const liked = response.data.liked;
            setLikeCount(likeCount);
            setLiked(liked);
        } catch (error) {
            console.error("Failed to like comment:", error);
            if (error.response && error.response.status === 500) {
                alert("로그인 후 반응할 수 있습니다.");
            }
        }
    };

    const toggleDelete = async (code, type) => {
        const token = localStorage.getItem("token");
        try {
            // 댓글 좋아요 요청
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/delete`,
                {
                    token: token,
                    id: code,
                    type: type
                },
            );
            window.location.reload();
        } catch (error) {
            console.error("Failed to like comment:", error);
        }
    };
    
    const shareCurrentURL = async () => {
        const currentURL = window.location.href;
    
        // 사용자 환경이 모바일인지 확인
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    
        if (isMobile && navigator.share) {
            try {
                await navigator.share({
                    title: document.title,
                    text: "이 페이지를 공유합니다.",
                    url: currentURL,
                });
                console.log("공유 성공!");
            } catch (error) {
                console.error("공유 실패:", error);
            }
        } else {
            try {
                await navigator.clipboard.writeText(currentURL);
                alert("링크가 클립보드에 복사되었습니다!");
            } catch (err) {
                console.error("클립보드 복사 실패:", err);
                alert("공유할 수 없습니다. 직접 복사하여 공유해주세요.");
            }
        }
    };
    
    
    

    return (
      <>
        <div className="at-progress-ct">
            <div className="at-progress-bar" style={{ width: `${scrollPercent}%` }}></div>
        </div>
        <div className='at-main'>
            <div className='at-article-area'>
                <div className='at-article-header'>
                    {myId === articleData?.writer && (
                        <div className='at-user-tool'>
                            <div className='at-tool-menu' onClick={() => toggleDelete(articleData?.id, 'article')}>삭제하기</div>
                            <div className='at-tool-menu' onClick={() => window.location.href = `/community/edit/${id}`}>수정하기</div>
                        </div>
                    )}
                    <div 
                    onClick={() => window.location.href = `/community/${categoryData.id}`}
                    className="at-article-ct" 
                    style={{ backgroundColor: categoryData?.color, marginRight:6 }}
                    >
                        {categoryData?.name}
                    </div>

                    <div 
                    onClick={() => window.location.href = `/search/tag/${headData.id}`}
                    className="at-article-ct" 
                    style={{ backgroundColor: headData?.color }}
                    >
                        {headData?.name}
                    </div>
                    
                    

                    <h1>{articleData?.title}</h1>
                    <div className='at-profile-ct'>
                        <div className="at-profile-img wa-profile" onClick={() => window.location.href = `/profile/${writer?.id}`}>
                            <img src={writer?.profile}></img>
                        </div>
                        <div className='at-profile-text' onClick={() => window.location.href = `/profile/${writer?.id}`}>
                            <div className='at-profile-name'>{writer?.username}</div>
                            <div className='at-profile-desc'>
                                <FaEye/> {articleData?.view}
                                <FaRegCalendar/> {articleData?.date} 
                                {articleData?.edited !== 'none' && <> / 수정 {articleData?.edited}</>}

                                <FaRegClock />{readingTime}분 소모</div>
                        </div>
                        <div className='at-share' onClick={shareCurrentURL}>
                            <IoShareSocialSharp />
                        </div>
                    </div>
                    {articleData?.isExpert === "1" && (
                        <div className="article-l" style={{padding:25}}>
                            <span className="title"><FaCheckCircle  />익스퍼트가 작성한 글입니다</span>
                            <span>익스퍼트란? 전문가로 인증된 유저입니다.</span>

                            
                            <div className='cte-gointo'>
                                <span onClick={() => window.location.href = `/expert`}>자세히 알아보기 <MdArrowForwardIos/></span><RxDividerVertical/>
                                <span onClick={() => window.location.href = `/form?type=expert`}>익스퍼트 신청하기 <MdArrowForwardIos/></span>
                            </div>
                            
                        </div>
                    )}

                    
                </div>
                
                <div className='hr at-hr2' />
                <div className="at-content-html" dangerouslySetInnerHTML={{ __html: articleData?.article }} />

                <div className="at-tag-ct">
                {articleData?.tag.map((tag, index) => (
                    <a href={`/search/tag/${tag}`}>
                        <div key={index} className="at-tag">
                        #{tag}
                        </div>
                    </a>
                ))}
                </div>

                <div className='hr'></div>
                <div className='at-bottom-bar'>
                    {/* 좋아요 버튼 */}
                    <div className='at-like' onClick={toggleLike}>

                    {liked ? (
                        <FaHeart color="red" />
                    ) : (
                        <FaRegHeart />
                    )}
                    <span>{likeCount}</span> {/* 좋아요 수 표시 */}
                    </div>
                    <div className='at-comment'>
                        <FaRegCommentAlt />{commentCount}
                    </div>
                    <div className='at-right'>
                        <div className='at-like' onClick={toggleSave}>
                            {saved ? (
                                <FaBookmark /> 
                            ):(
                                <FaRegBookmark />
                            )}
                        </div>
                    </div>
                </div>
                <div className='hr'></div>
                <h4>댓글</h4>
                <div className='at-comment-ct'>
                    <SunEditor
                        mode="inline"
                        onChange={(content) => setCommentData(content)}
                        setContents={commentData}
                        placeholder="댓글 작성"
                        lang="ko"
                        setOptions={{
                            height: '140px',
                            maxHeight: '550px',
                            placeholder: '여기에 내용을 입력해주세요...',
                            buttonList: [
                                ['undo'],
                                ['formatBlock'],
                                ['bold', 'italic', 'underline', 'strike', 'fontColor', 'hiliteColor'],
                                ['align', 'horizontalRule'],
                                ['table', 'link', 'image'],
                            ],
                            font: ['Wanted Sans', 'Arial', 'Comic Sans MS', 'Courier New', 'Georgia', 'Tahoma', 'Verdana'],
                            fontSize: [8, 10, 12, 14, 16, 18, 20, 24, 28, 32, 36],
                            defaultStyle: 'font-size: 16px; font-family: Arial, sans-serif;',
                        }}
                    />

                    <div className='at-comment-bottom'>
                        <div className='at-comment-count'>0/400</div>
                        <button className='at-comment-submit' onClick={handleComment}>등록</button>

                    </div>
                </div>

                <div className='at-comment-section'>
                    <div className="at-comment-select">
                        <button onClick={() => setSortType('latest')}>최신순</button>
                        <button onClick={() => setSortType('popular')}>인기순</button>
                    </div>
                    {sortedComments.map((comment) => (
                        <div key={comment.id} className='at-comment-box'>
                            {myId === comment.writer.id && (
                                <div className='at-comment-delete' onClick={() => toggleDelete(comment.id, 'comment')}>삭제하기</div>
                            )}
                        
                            <div className='at-comment-ct-header' onClick={() => window.location.href = `/profile/${comment.writer.id}`}>
                                <div className='at-comment-ct-profile wa-profile'>
                                    <img src={comment.writer.profile}></img>
                                </div>
                                <div className='at-comment-ct-name'>{comment.writer.username}
                                {comment.writer.expert === '1' && <FaCheckCircle className='check' />}</div>
                                <div className='at-comment-ct-info' style={{ marginLeft: '5px' }}>
                                    <FaRegClock /> {comment.date}
                                </div>  
                            </div>

                            <div className='at-comment-ct-content'
                                dangerouslySetInnerHTML={{ __html: comment.content }}
                            ></div>

                            <div className='at-comment-ct-info'>
                                {comment && comment.likedThis ? (
                                    <span onClick={() => handleCommentLike(comment.id)}>
                                        <FaHeart style={{ fill: 'red' }} /> 좋아요 {comment.like}
                                    </span>
                                ) : (
                                    <span onClick={() => handleCommentLike(comment.id)}>
                                        <FaRegHeart /> 좋아요 {comment.like}
                                    </span>
                                )}
                                <div onClick={() => handleReplyToggle(comment.id)} style={{ cursor: 'pointer' }}>
                            
                                    <FaRegCommentAlt /> 답글 달기
                                </div>
                            </div>

                            {comment.replyCount > 0 && (
                                <div className='at-comment-repl' onClick={() => handleReplyToggle(comment.id)}>
                                    <FaChevronDown />
                                    답글 {comment.replyCount}개
                                </div>
                            )}

                            <div className='at-comment-repl-box' style={{ display: openReplyBox === comment.id ? 'block' : 'none' }}>
                                <div className='at-repl-ct'>
                                    <SunEditor
                                        mode="inline"
                                        onChange={handleReplChange}
                                        setContents={repl}
                                        placeholder="댓글 작성"
                                        lang="ko"
                                        setOptions={{
                                            height: '140px',
                                            maxHeight: '550px',
                                            placeholder: '여기에 내용을 입력해주세요...',
                                            buttonList: [
                                                ['undo'],
                                                ['formatBlock'],
                                                ['bold', 'italic', 'underline', 'strike', 'fontColor', 'hiliteColor'],
                                                ['align', 'horizontalRule'],
                                                ['table', 'link', 'image'],
                                            ],
                                            font: ['Wanted Sans', 'Arial', 'Comic Sans MS', 'Courier New', 'Georgia', 'Tahoma', 'Verdana'],
                                            fontSize: [8, 10, 12, 14, 16, 18, 20, 24, 28, 32, 36],
                                            defaultStyle: 'font-size: 16px; font-family: Arial, sans-serif;',
                                        }}
                                    />
                                    <button className='at-comment-submit' onClick={() => handleRepl(comment.id)} style={{minWidth:80}}>등록</button>
                                </div>
                                {comment.reply.map((repl) => (
                                    <div key={repl.id} className='at-comment-box'>
                                        {myId === repl.writer.id && (
                                            <div className='at-comment-delete' onClick={() => toggleDelete(repl.id, 'comment')}>삭제하기</div>
                                        )}
                                        <div className='at-comment-ct-header' onClick={() => window.location.href = `/profile/${repl.writer.id}`}>
                                        <div className='at-comment-ct-profile wa-profile'>
                                            <img src={repl.writer.profile}></img>
                                        </div>
                                            <div className='at-comment-ct-name'>{repl.writer.username}
                                            {repl.writer.expert === '1' && <FaCheckCircle className='check' />}</div>
                                            <div className='at-comment-ct-info' style={{ marginLeft: '5px' }}>
                                                <FaRegClock /> {repl.date}
                                            </div>  
                                        </div>
                                        <div className='at-comment-ct-content'
                                            dangerouslySetInnerHTML={{ __html: repl.content }}
                                        ></div>

                                        <div className='at-comment-ct-info'>
                                            {repl && repl.likedThis ? (
                                                <span onClick={() => handleCommentLike(repl.id)}>
                                                    <FaHeart style={{ fill: 'red' }} /> 좋아요 {repl.like}
                                                </span>
                                            ) : (
                                                <span onClick={() => handleCommentLike(repl.id)}>
                                                    <FaRegHeart /> 좋아요 {repl.like}
                                                </span>
                                            )}
                                            {/* <div onClick={() => handleReplToRepl(repl.writer.id)} style={{ cursor: 'pointer' }}>
                                                <FaRegCommentAlt /> 답글 달기
                                            </div> */}
                                        </div>
                                    </div>
                                ))}
                            </div>



                           
                        </div>
                    ))}
                </div>


            </div>


            <div className='at-side-area'>
                <div className='at-side-box' style={{marginBottom:15}}>
                    <h4>작성자의 또다른 아티클</h4>

                    {writerArticle.map((article) => (
                        <div className="cm-card-list-item" onClick={() => window.location.href = `/community/article/${article.id}`}>
                            <div className='cm-view'><FaEye />{article.view}</div>
                    
                            {article.previewImage ? 
                            <div className="cm-card-list-item-thumb wa-thumb"><img src={article.previewImage}></img></div>
                            : null }
                            <div className="cm-card-list-item-content">
                                <div className="cm-card-list-item-title"><span style={{fontWeight:600,color:article.headColor}}>[{article.headName}] </span>{article.title}</div>
                                <div className="cm-card-list-item-meta">
                                    <IoTimeOutline />
                                    <span className="meta-time">{article.date}</span>
                                    <span className="meta-divider">·</span>
                                    <span className="meta-likes">
                                        <IoHeart />
                                        {article.like}
                                    </span>
                                    <span className="meta-divider">·</span>
                                    <span className="meta-comments">
                                        <FaCommentAlt className='icon-smaller' />
                                        {article.commentCount}
                                    </span>
                                    <span className="meta-divider">·</span>
                                    <span className="meta-time">
                                    <FaUser />
                                    {article.username} 
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))}
                    
                    <div className="article-l-go" style={{margin:10}} onClick={() => window.location.href = `/profile/${writer?.id}`}>
                        모두보기 <MdOutlineArrowForwardIos />
                    </div>
                </div>
                <div className='at-side-box'>
                    <h4>당신이 좋아할 아티클</h4>

                    {myArticle.map((article) => (
                        <div className="cm-card-list-item" onClick={() => window.location.href = `/community/article/${article.id}`}>
                            <div className='cm-view'><FaEye />{article.view}</div>
                    
                            {article.previewImage ? 
                            <div className="cm-card-list-item-thumb wa-thumb"><img src={article.previewImage}></img></div>
                            : null }
                            <div className="cm-card-list-item-content">
                                <div className="cm-card-list-item-title"><span style={{fontWeight:600,color:article.headColor}}>[{article.headName}] </span>{article.title}</div>
                                <div className="cm-card-list-item-meta">
                                    <IoTimeOutline />
                                    <span className="meta-time">{article.date}</span>
                                    <span className="meta-divider">·</span>
                                    <span className="meta-likes">
                                        <IoHeart />
                                        {article.like}
                                    </span>
                                    <span className="meta-divider">·</span>
                                    <span className="meta-comments">
                                        <FaCommentAlt className='icon-smaller' />
                                        {article.commentCount}
                                    </span>
                                    <span className="meta-divider">·</span>
                                    <span className="meta-time">
                                    <FaUser />
                                    {article.username} 
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>


            </div>
        </div>
      </>
    );
  }

export default Article;